import React from "react";

const NonIndividualForeign = () => {
  return (
    <div>
      <div className="bg-[#EAF4FA] max-w-[100vw] p-4 lg:px-4 mt-4 rounded-lg shadow-sm border border-[#D6E9F6]">
        <div className="flex gap-2 items-start flex-wrap md:flex-nowrap">
          <div className="mt-2 text-[#63c0eb]">
            <svg
              width="34"
              height="17"
              viewBox="0 0 34 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0 8.5C0 13.1944 3.80558 17 8.5 17V0C3.80558 0 0 3.80558 0 8.5Z"
                fill="currentColor"
              />
              <path
                d="M8.5 8.5C8.5 13.1944 12.3056 17 17 17V0C12.3056 0 8.5 3.80558 8.5 8.5Z"
                fill="currentColor"
              />
              <circle cx="25.5" cy="8.5" r="8.5" fill="currentColor" />
            </svg>
          </div>

          <div className="flex-1">
            <p className="text-[20px] font-semibold text-black text-left mb-6 uppercase">
              FORM NO 96 ( for Non - Individuals) for citizen of Outside India (Foreign Citizens)
            </p>

            <div className="bg-white overflow-hidden shadow-sm rounded-lg border border-[#D6E9F6]">
              <div className="overflow-x-auto">
                <table className="min-w-full border-collapse text-[12px] md:text-[14px]">
                  <thead className="bg-[#D6E9F6]">
                    <tr>
                      <th className="p-3 border border-gray-200 text-center font-bold" style={{ width: "80px" }}>SR NO</th>
                      <th className="p-3 border border-gray-200 text-left font-bold" style={{ width: "250px" }}>Applicant</th>
                      <th className="p-3 border border-gray-200 text-left font-bold">Documents as proof of identity, address and date of birth or date of incorporation</th>
                    </tr>
                  </thead>
                  <tbody className="text-[#4B4B4B]">
                    <tr>
                      <td className="p-3 border border-gray-200 text-center align-top">1</td>
                      <td className="p-3 border border-gray-200 font-semibold align-top">Limited Liability Partnership registered outside India</td>
                      <td rowSpan={5} className="p-3 border border-gray-200 align-top">
                        <strong>(a)</strong> Copy of Certificate of Registration issued in the country where the applicant is located, duly attested by "Apostille" (in respect of countries which are signatories to the Hague Apostille Convention of 1961), or by Indian embassy or High Commission or consulate in the country where the applicant is located or authorised officials of overseas branches of Scheduled Banks registered in India; or <br /><br />
                        <strong>(b)</strong> copy of registration certificate issued in India or of approval granted to set up office in India by Indian Authorities.
                      </td>
                    </tr>
                    <tr>
                      <td className="p-3 border border-gray-200 text-center align-top">2</td>
                      <td className="p-3 border border-gray-200 font-semibold align-top">Company registered outside India</td>
                    </tr>
                    <tr>
                      <td className="p-3 border border-gray-200 text-center align-top">3</td>
                      <td className="p-3 border border-gray-200 font-semibold align-top">Firm formed or registered outside India</td>
                    </tr>
                    <tr>
                      <td className="p-3 border border-gray-200 text-center align-top">4</td>
                      <td className="p-3 border border-gray-200 font-semibold align-top">Association of persons (Trusts) formed outside</td>
                    </tr>
                    <tr>
                      <td className="p-3 border border-gray-200 text-center align-top">5</td>
                      <td className="p-3 border border-gray-200 font-semibold align-top">Association of persons (other than Trusts) or body of individuals or local authority or person formed or any other entity (by whatever name called) registered outside India</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>


      {/* <div className="bg-[#EAF4FA] max-w-[100vw] p-4 lg:px-4 mt-4 rounded-lg shadow-sm border border-[#D6E9F6]">
        <div className="flex gap-2 items-start flex-wrap md:flex-nowrap">
          <div className="mt-2 text-[#63c0eb]">
            <svg
              width="34"
              height="17"
              viewBox="0 0 34 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0 8.5C0 13.1944 3.80558 17 8.5 17V0C3.80558 0 0 3.80558 0 8.5Z"
                fill="currentColor"
              />
              <path
                d="M8.5 8.5C8.5 13.1944 12.3056 17 17 17V0C12.3056 0 8.5 3.80558 8.5 8.5Z"
                fill="currentColor"
              />
              <circle cx="25.5" cy="8.5" r="8.5" fill="currentColor" />
            </svg>
          </div>

          <br />

          <div className="flex-1">
            <p className="text-[20px] font-semibold text-black text-left mb-6 uppercase">
              FORM NO 96 ( for Non - Individuals) for citizen of Outside India (Foreign Citizens)
            </p>

            <div className="bg-white overflow-hidden shadow-sm rounded-lg border border-[#D6E9F6]">
              <div className="overflow-x-auto">
                <table className="min-w-full border-collapse text-[12px] md:text-[14px]">
                  <thead className="bg-[#D6E9F6]">
                    <tr>
                      <th className="p-3 border border-gray-200 text-left font-bold" style={{ width: "250px" }}>Applicant</th>
                    </tr>
                  </thead>
                  <tbody className="text-[#4B4B4B]">
                    <tr>
                      <td className="p-3 border border-gray-200 text-center align-top">
                        <strong>
                          Limited Liability Partnership, Company, Firm, Association of persons (Trusts), Association of persons (other than Trusts) or body of individuals or local authority or person formed or any other entity (by whatever namecalled) (registered outside India)
                        </strong>
                      </td>
                    </tr>
                    <tr>
                      <td className="p-3 border border-gray-200 align-top">
                        <strong>(a)</strong> Copy of Certificate of Registration issued in the country where the applicant is located, duly attested by "Apostille" (in respect of countries which are signatories to the Hague Apostille Convention of 1961), or by Indian embassy or High Commission or consulate in the country where the applicant is located, or authorised officials of overseas branches of Scheduled Banks registered in India; or<br /><br />
                        <strong>(b)</strong> copy of registration certificate issued in India or of approval granted to set up office in India by Indian Authorities
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div> */}
    </div>

    
  );
};

export default NonIndividualForeign;